(function () {
    'use strict';

    angular.module('ib-pmt-nav-tab-module', [
        'ib-pmt-credit-card-tab-module',
        'ib-pmt-external-tab-module',
        'ib-pmt-online-banking-tab-module',
        'ib-pmt-external-form-module'
    ]);
})();